if (!customElements.get('readers-featured-products')) {
    class ReadersFeaturedProducts extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.style.display = 'block';
        }
    }

    customElements.define('readers-featured-products', ReadersFeaturedProducts);
}